<script>import { trackComponent } from "@sentry/svelte";
trackComponent({ "trackInit": true, "trackUpdates": true, "componentName": "FieldsetBuyer" });
import { InputStreet, InputBuilding, InputPostalCode, InputLocality, SelectCountry } from "../../../index.js";
import { Button } from "../../../../../elements/index.js";
import { Heading } from "../../../../../typography/index.js";
import { ContactForm, FieldsetContact } from "../../../../contact/index.js";
export let address = {};
export let action = "create";
export let showCancel = false;
export let onCancel = () => {
};
export let organizationKey;
export let contact = { type: "contact" };
</script>

<div class = 's8-row-of-2'>
    <InputStreet bind:value = { address.street } isRequired />
    <InputBuilding bind:value = { address.building } />
</div>

<div class = 's8-row-of-3'>
    <InputPostalCode bind:value = { address.postalCode } isRequired />
    <InputLocality bind:value = { address.locality } isRequired />
    <SelectCountry bind:key = { address.countryCode }/>
</div>

<Heading size = 'sm'>Contact Person</Heading>

<ContactForm
    { action }
    { organizationKey }
    { contact }
>
    <FieldsetContact bind:contact showType = { false } />
</ContactForm>

<div class = 's8-form-buttons'>
    <Button
        type = 'submit'
        size = { `${ showCancel ? 'sm' : 'lg' }` }
        label = 'Save'
        color = 'primary'
        css = { `${ showCancel ? '' : 'w-full' }` }
    />

    {#if showCancel}
        <Button
            type = 'button'
            size = 'sm'
            label = 'Cancel'
            color = 'neutral'
            on:click = { onCancel }
        />
    {/if}
</div>


<style>

    div[class^='s8-row'] {
        display: grid;
        -moz-column-gap: 10px;
             column-gap: 10px;
    }

        div[class^='s8-row'].s8-row-of-2 {
            grid-template-columns: repeat(2, 1fr);
        }

        div[class^='s8-row'].s8-row-of-3 {
            grid-template-columns: repeat(3, 1fr);
        }

    div.s8-form-buttons {
        display: flex;
        justify-content: space-between;
    }</style>